import { PAGE_EDITOR_HISTORY_TARGET_IDS } from '@/stores/page-editor/constants';
import type { AiProposal } from '@/types/ai-proposal';
import { isActiveProposalStatus, isPreviewableTargetedProposal } from './helpers';

export const getConflictingProposalIdsForUndo = (
  entryTargetId: string | null,
  proposals: AiProposal[],
): string[] => {
  if (
    entryTargetId === null ||
    entryTargetId === PAGE_EDITOR_HISTORY_TARGET_IDS.header ||
    entryTargetId === PAGE_EDITOR_HISTORY_TARGET_IDS.footer
  ) {
    return [];
  }

  return proposals
    .filter(
      (proposal) =>
        isActiveProposalStatus(proposal.status) &&
        isPreviewableTargetedProposal(proposal) &&
        proposal.targetSectionId === entryTargetId,
    )
    .map((proposal) => proposal.id);
};
